import Alpine from './alpine'

/**
 * Live View.
 *
 * Polls one endpoint for the whole snapshot rather than one per tile: it is a
 * single cheap query set, and a partial refresh would show a visitor count from
 * one second next to an order count from another.
 */
Alpine.data('liveView', (initial = {}, endpoint = '') => ({
    data: initial,
    endpoint,
    updatedAt: Date.now(),
    timer: null,
    /*
     * Back off when the tab is hidden. A dashboard left open on a second monitor
     * overnight should not keep a database busy until morning.
     */
    intervalVisible: 10000,
    intervalHidden: 60000,

    start() {
        this.schedule()

        document.addEventListener('visibilitychange', () => {
            if (! document.hidden) {
                this.refresh()
            }

            this.schedule()
        })
    },

    schedule() {
        if (this.timer) {
            window.clearInterval(this.timer)
        }

        const every = document.hidden ? this.intervalHidden : this.intervalVisible

        this.timer = window.setInterval(() => this.refresh(), every)
    },

    async refresh() {
        try {
            const response = await fetch(this.endpoint, {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
            })

            if (! response.ok) {
                return
            }

            this.data = await response.json()
            this.updatedAt = Date.now()
        } catch (e) {
            // A missed poll is not worth reporting: the next one is seconds away.
        }
    },

    behaviourRows() {
        const behaviour = this.data.behaviour ?? {}

        return [
            { label: 'Browsing', value: behaviour.browsing ?? 0 },
            { label: 'With items in cart', value: behaviour.in_cart ?? 0 },
            { label: 'In checkout', value: behaviour.in_checkout ?? 0 },
        ]
    },

    updatedLabel() {
        const seconds = Math.round((Date.now() - this.updatedAt) / 1000)

        if (seconds < 15) {
            return 'Live'
        }

        return seconds < 90 ? `${seconds}s ago` : `${Math.round(seconds / 60)}m ago`
    },

    number(value) {
        return new Intl.NumberFormat().format(Number(value ?? 0))
    },
}))
